import moment from 'moment';
import { NotificationManager } from 'react-notifications';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import database from '../../system/model/firebase/firebase';
// eslint-disable-next-line import/no-cycle
import { backendTypes } from './applicantActions';
import history from '../../system/router/history';
import { bodyAdminMailNotification } from '../../system/helpers/main';
import { vacanciesTypes } from '../reducer/vacanciesReducer';
import { jobTypes } from '../reducer/jobsReducer';
import { onChangeLoad } from '../reducer/loadReducer';
import { setDocumenteElastic } from '../../system/utils/axiosHelper';
import production from '../../system/access/environment';

export const vacancyTypes = {
  GET_DATA: 'vacancy/GETTING_DATA',
  GET_COLUMN: 'vacancy/GETTING_COLUMN',
  GET_DATA_FIRESTONE: 'vacancy/GET_DATA_FIRESTONE',
  GET_CANIDATE: 'vacancy/GET_CANIDATE',
  GET_COLUMN_NAMES: 'vacancy/GETTING_COLUMN_NAMES',
  GET_TITLE_VACANCY: 'vacancy/GETTING_TITLE_VACANCY',
  UPDATE_COLUMN_CANIDATE: 'vacancy/UPDATE_COLUMN_CANIDATE',
  ADD_COLUMN: 'vacancy/ADD_COLUMN',
  UPDATE_NAME_COLUMN: 'vacancy/UPDATE_NAME_COLUMN',
  DELETE_COLUMN: 'vacancy/DELETE_COLUMN',
  POST_COMENTS: 'vacancy/POST_COMENTS',
  LOAD: 'vacancy/LOAD',
  UPDATE_USER: 'vacancy/UPDATE_USER',
  UPDATE_USER_DATA: 'vacancy/UPDATE_USER_DATA',
  UPDATE_USER_COLUMN: 'vacancy/UPDATE_USER_COLUMN',
  USER_COLUMNS: 'vacancy/USER_COLUMNS',
  USER_COLUMNS_SELECTED: 'vacancy/USER_COLUMNS_SELECTED',
  LIST_USER: 'vacancy/LIST_USER',
  UPDATE: 'vacancy/UPDATE',
  id_Vacancy: 'vacancy/id',
  SaveCandidate: 'vacancy/SaveCandidate',
  SELEC_CANDIDATE: 'vacancy/SELEC_CANDIDATE',
  GET_COLUMN_NAMES_P: 'vacancy/GET_COLUMN_NAMES_P',
  Names: 'vacancy/Names',
  parsedFetch_Extra: 'vacancy/parsedFetch_Extra',
  Column_CHECK_Candidate: 'vacancy/Column_CHECK_Candidate',
};

export const createNewLocal = (payload) => ({
  type: vacanciesTypes.CREATE_NEW,
  payload,
});
export const editLocal = (updates, id) => ({
  type: vacanciesTypes.EDIT_DATA,
  updates,
  id,
});
export const createNew =
  (payload = {}) =>
  async (dispatch, getState) => {
    // Este metodo es para crear nuevas vacantres
    try {
      const { uid } = getState().auth;
      const { platformName } = getState().platform;
      const { company, platform } = getState();
      // Se coloca un ID dinamico para identificar la vacante
      const jobID = uuidv4();
      // Este es el objeto que se manda a firebase para crear la vacante
      const publicData = {
        Permission: platform.autoAcceptJobs ? 'accept' : 'waiting',
        Status: true,
        companyAbout: company.companyAbout,
        companyName: company.companyName,
        createdAt: moment().valueOf(),
        logo: company.companyLogo,
        mode: '',
        notifyWhom: [],
        redirectTo: '',
        redirectable: false,
        vacancyOwner: uid,
        notify: false,
        ATS: false,
        jobID,
        notifyWhomArray: [company.companyEmail],
        ...payload,
      };
      if (platform.autoAcceptJobs) {
        let category = [];
        const {
          jobID,
          workType,
          companyName,
          ATS,
          img,
          jobTitle,
          logo,
          locationName,
          createdAt,
          carrer,
          seniority,
          campus,
          remoto,
          Permission,
          vacancyOwner,
        } = publicData;

        if (publicData?.category) {
          // eslint-disable-next-line no-nested-ternary
          category = Array.isArray(publicData?.category)
            ? publicData?.category?.map((cat) => cat.label)
            : typeof publicData?.category === 'object'
            ? publicData?.category?.label
            : publicData?.category;
        }
        await setDocumenteElastic({
          action: 'save',
          index: production ? 'jobsindex' : 'jobsindexdev',
          data: {
            jobID,
            category,
            workType,
            companyName,
            ATS,
            img,
            jobTitle,
            logo,
            locationName,
            createdAt,
            carrer,
            seniority,
            campus,
            remoto,
            vacancyOwner,
            Permission: Permission || 'accept',
            uniOwner: platformName,
            objectID: publicData.jobID,
          },
        });
        NotificationManager.success('Se guardo correctamente, se mostrara en la página principal');
      }

      const sendable = {
        Permission: platform.autoAcceptJobs ? 'accept' : 'waiting',
        Status: true,
        companyAbout: company.companyAbout,
        companyName: company.companyName,
        createdAt: moment().valueOf(),
        logo: company.companyLogo,
        mode: '',
        notifyWhom: [],
        redirectTo: '',
        redirectable: false,
        vacancyOwner: uid,
        notify: false,
        ATS: false,
        notifyWhomArray: [company.companyEmail],
        jobID,
        ...payload,
      };
      // Metodos de actualizaxion para la base de datos
      await database.collection(`${platform.platformName}/data/vacancies`).doc(jobID).set(publicData);
      await database.collection(`${platform.platformName}/data/companies/${uid}/jobs`).doc(jobID).set(sendable);
      dispatch(createNewLocal(publicData));
      // Crear las columnas
      const Column = {
        '1Column': { name: 'Filtro Personal 1', index: 0 },
        '2Column': { name: 'Filtro Personal 2', index: 1 },
        '4Column': { name: 'Aceptado(s)', index: 3 },
        '3Column': { name: 'Rechazados', index: 2 },
      };

      const subTemp = [];
      Object.values(Column).forEach((data, inde) => {
        const refColum = `ColumDefault${inde}`;
        subTemp.push(
          database
            .collection(`${platform.platformName}/data/companies/${uid}/jobs/${jobID}/vacation_column`)
            .doc(refColum)
            .set(data)
        );
      });
      await Promise.all(subTemp);
      // Identificador para saber si notificar a la plataforma
      if (platform?.vacanciesNotification) {
        await axios.request({
          url: 'https://us-central1-universia-prod.cloudfunctions.net/sendEmailHTML',
          method: 'POST',
          data: bodyAdminMailNotification(
            platform,
            platform.platformFullName,
            platform.platformContact,
            platform.adminName,
            platform.platformURL,
            company.companyName,
            publicData.jobTitle
          ),
          crossDomain: true,
        });
      }
      // Metodo para regresar a la pagina anterior
      history.goBack();
      setTimeout(() => {
        NotificationManager.success('Se agregó la vacante de manera correcta.');
      }, 1000);
      dispatch(onChangeLoad(true));
      dispatch({
        type: jobTypes.JOBEDITCLEAR,
      });
    } catch (e) {
      dispatch(onChangeLoad(true));
      NotificationManager.error('Ocurrió un error en el servidor.');
    }
  };

export const deteleVacancy = () => () => {
  try {
    // const jobs = [...getState().vacancies];jobID
    // Metodo para borrar la vacante PD: No se termino por que en el AtsJsx no se permite eliminar la vacante
    // console.log(jobs, jobID);
  } catch (e) {
    NotificationManager.error('Error al eliminar la vacante.');
  }
};

export const editPausedPlay =
  (jobID, status = true) =>
  async (dispatch, getState) => {
    try {
      const { vacancies: jobs, platform, auth } = getState();
      const { uid } = auth;
      const findJobs = jobs.slice().find((job) => job.jobID === jobID);
      findJobs.Status = status;

      await database.collection(`${platform.platformName}/data/companies/${uid}/jobs`).doc(jobID).update(findJobs);
      try {
        await database.collection(`${platform.platformName}/data/vacancies`).doc(jobID).update(findJobs);
      } catch (e) {
        await database.collection(`${platform.platformName}/data/vacancies`).doc(jobID).set(findJobs);
      }

      dispatch(editLocal(findJobs, jobID));
      dispatch(onChangeLoad(true));
      dispatch({
        type: jobTypes.JOBEDITCLEAR,
      });
      if (status) {
        let category = [];

        const {
          jobID,
          workType,
          companyName,
          ATS,
          img,
          jobTitle,
          logo,
          locationName,
          createdAt,
          carrer,
          seniority,
          campus,
          remoto,
          Permission,
          vacancyOwner,
        } = findJobs;

        if (findJobs?.category) {
          // eslint-disable-next-line no-nested-ternary
          category = Array.isArray(findJobs?.category)
            ? findJobs?.category?.map((cat) => cat.label)
            : typeof findJobs?.category === 'object'
            ? findJobs?.category?.label
            : findJobs?.category;
        }
        await setDocumenteElastic({
          action: 'save',
          index: production ? 'jobsindex' : 'jobsindexdev',
          data: {
            jobID,
            category,
            workType,
            companyName,
            ATS,
            img,
            jobTitle,
            logo,
            locationName,
            createdAt,
            carrer,
            seniority,
            campus,
            remoto,
            vacancyOwner,
            Permission: Permission || 'accept',
            uniOwner: platform?.platformName,
            objectID: findJobs.jobID,
          },
        });
      } else {
        await setDocumenteElastic({
          action: 'delete',
          index: production ? 'jobsindex' : 'jobsindexdev',
          id: jobID,
        });
      }
      NotificationManager.success('Vacante pausada con Exito');
    } catch (e) {
      console.error(e);
      NotificationManager.error('Ocurrió un error en el servidor.');
      dispatch(onChangeLoad(true));
    }
  };

export const updateVacancy =
  (payload = {}) =>
  async (dispatch, getState) => {
    try {
      const { uid } = getState().auth;
      const { company, platform } = getState();
      const { jobID } = payload;
      const publicData = {
        Permission: platform.autoAcceptJobs ? 'accept' : 'waiting',
        Status: true,
        companyAbout: company.companyAbout,
        companyName: company.companyName,
        createdAt: moment().valueOf(),
        logo: company.companyLogo,
        mode: '',
        notifyWhom: [],
        redirectTo: '',
        redirectable: false,
        vacancyOwner: uid,
        notify: false,
        ATS: false,
        jobID,
        notifyWhomArray: [company.companyEmail],
        ...payload,
      };
      const sendable = {
        Permission: platform.autoAcceptJobs ? 'accept' : 'waiting',
        Status: true,
        companyAbout: company.companyAbout,
        companyName: company.companyName,
        createdAt: moment().valueOf(),
        logo: company.companyLogo,
        mode: '',
        notifyWhom: [],
        redirectTo: '',
        redirectable: false,
        vacancyOwner: uid,
        notify: false,
        ATS: false,
        notifyWhomArray: [company.companyEmail],
        jobID,
        ...payload,
      };
      console.log('Atualizar Elastic');
      if (platform.autoAcceptJobs) {
        let category = [];

        const {
          jobID,
          workType,
          companyName,
          ATS,
          img,
          jobTitle,
          logo,
          locationName,
          createdAt,
          carrer,
          seniority,
          campus,
          remoto,
          Permission,
          vacancyOwner,
        } = publicData;

        if (publicData?.category) {
          // eslint-disable-next-line no-nested-ternary
          category = Array.isArray(publicData?.category)
            ? publicData?.category?.map((cat) => cat.label)
            : typeof publicData?.category === 'object'
            ? publicData?.category?.label
            : publicData?.category;
        }
        await setDocumenteElastic({
          action: 'update',
          index: production ? 'jobsindex' : 'jobsindexdev',
          data: {
            jobID,
            category,
            workType,
            companyName,
            ATS,
            img,
            jobTitle,
            logo,
            locationName,
            createdAt,
            carrer,
            seniority,
            campus,
            remoto,
            vacancyOwner,
            Permission: Permission || 'accept',
            uniOwner: platform?.platformName,
            objectID: publicData.jobID,
          },
        });
        NotificationManager.success('Se guardo correctamente, se mostrara en la página principal');
      }

      await database.collection(`${platform.platformName}/data/vacancies`).doc(jobID).set(publicData);
      await database.collection(`${platform.platformName}/data/companies/${uid}/jobs`).doc(jobID).set(sendable);
      dispatch(editLocal(publicData, jobID));
      if (platform?.vacanciesNotification) {
        await axios.request({
          url: 'https://us-central1-universia-prod.cloudfunctions.net/sendEmailHTML',
          method: 'POST',
          data: bodyAdminMailNotification(
            platform.platformFullName,
            platform.platformContact,
            platform.adminName,
            platform.platformURL,
            company.companyName,
            publicData.jobTitle
          ),
          crossDomain: true,
        });
      }
      history.goBack();
      setTimeout(() => {
        NotificationManager.success('Se agregó la vacante de manera correcta.');
      }, 1000);
      dispatch(onChangeLoad(true));
      dispatch({
        type: jobTypes.JOBEDITCLEAR,
      });
    } catch (e) {
      dispatch(onChangeLoad(true));
      NotificationManager.error('Ocurrió un error en el servidor.');
    }
  };

const ArrrayColumnDe = ['Filtro 1', 'Rechazados', 'Aceptado(s)'];
export const getColumn = ({ uid, id, parsedFetch }) => {
  return (dispatch, getState) => {
    const { platform } = getState();
    let candidates = getState().backend?.vacancy?.candidates.slice();
    dispatch({
      type: backendTypes.Load,
      load: true,
    });
    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(id)
      .collection('vacation_column')
      .get()
      .then((e) => {
        const columnsTotal = e.docs;
        if (columnsTotal.length <= 0) {
          // console.log('Crear las columnas');
          ArrrayColumnDe.forEach((name, index) => {
            database
              .collection(`${platform.platformName}/data/companies`)
              .doc(uid)
              .collection('jobs')
              .doc(id)
              .collection('vacation_column')
              .add({
                name,
                index,
              });
          });
        } else {
          const arrayColumn = [];
          columnsTotal.forEach((o) => {
            arrayColumn.push({
              ...o.data(),
              docID: o.id,
            });
            // console.log(o.data())
          });
          dispatch({
            type: backendTypes.VACANCY,
            column: arrayColumn.sort((a, b) => a.index - b.index),
          });
          arrayColumn.forEach((item) => {
            const columnCandidate = item.candidates;
            if (columnCandidate) {
              columnCandidate.forEach((itemCan) => {
                const decition = candidates.filter((e) => e.docID === itemCan.idUser);
                if (decition.length > 0) {
                  candidates = candidates.filter((e) => e.docID !== itemCan.idUser);
                }
              });
            }
          });
          dispatch({
            candidates,
            candidates_Store: parsedFetch,
            type: backendTypes.GET_DATA,
          });

          // console.log('Guardar las columnas que existen');
        }
      });
  };
};

export const addTestConfig = (payload = {}) => {
  return (dispatch, getState) => {
    const uid = getState().company.objectID;
    const { platform } = getState();
    const { testConfig } = payload;
    const { testSelected } = payload;
    const { testAssigned } = payload;
    const { testCreated } = payload;
    const jobData = { ...payload.vacancyData, testConfig, testSelected, testAssigned, testCreated };
    const jobCreatedData = { ...payload.vacancyData, testConfig, testSelected, testAssigned };
    dispatch(editLocal(jobData, payload.vacancyData.jobID));
    if (testCreated) {
      return database
        .collection(`${platform.platformName}/data/companies/${uid}/jobs`)
        .doc(payload.vacancyData.jobID)
        .update({ testConfig, testCreated, testAssigned, testSelected })
        .then(() => {
          database
            .collection('test-in-progress')
            .add({ ...payload.testData })
            .then(() => {
              dispatch(editLocal(jobData, payload.vacancyData.jobID));
            });
        });
    }
    return database
      .collection(`${platform.platformName}/data/companies/${uid}/jobs`)
      .doc(payload.vacancyData.jobID)
      .update({ testAssigned, testSelected })
      .then(() => {
        database
          .collection('test-in-progress')
          .add({ ...payload.testData })
          .then(() => {
            dispatch(editLocal(jobCreatedData, payload.vacancyData.jobID));
          });
      });
  };
};
